import { t } from 'i18next';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { getTenantInfoByKey } from '../../../helpers/helpers';

export const AreaSearcher = ({ handleChangeSearchText }) => {
    const navigate = useNavigate();
    const nameOfAreas = getTenantInfoByKey('area_name');

    return (
        <>
            <div className='mt-2 mb-2'>
                <input
                    placeholder={t('SEARCH')}
                    type={"text"}
                    name={'searchAreas'}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                />
            </div>

            <div className='text-end mt-3 mb-3'>
                <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '19px', display: 'inline' }}
                    className='m-0 me-1 gray-950-color'
                    onClick={() => navigate('/settings/entityManagment/areasMaganagement/create')}
                    type="button"
                >
                    {`+ ${t('CREATE')} ${nameOfAreas}`}
                </p>
            </div>
        </>
    )
}
